import { render, staticRenderFns } from "./foot-nav.vue?vue&type=template&id=fb006558"
import script from "./foot-nav.vue?vue&type=script&lang=js"
export * from "./foot-nav.vue?vue&type=script&lang=js"
import style0 from "./foot-nav.vue?vue&type=style&index=0&id=fb006558&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\vescort-platform-pc-website\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb006558')) {
      api.createRecord('fb006558', component.options)
    } else {
      api.reload('fb006558', component.options)
    }
    module.hot.accept("./foot-nav.vue?vue&type=template&id=fb006558", function () {
      api.rerender('fb006558', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/foot-nav.vue"
export default component.exports